import * as React from 'react';

import { cn } from '../../../lib/utils';
import { Badge } from '../../ui/badge';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface SiteTypeBadgeProps {
  className?: string;
  label: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

/**
 * Displays a site type as an outline badge.
 * Extracted from the inline pattern in sites-table.tsx.
 */
export function SiteTypeBadge({ className, label }: SiteTypeBadgeProps): React.JSX.Element {
  return (
    <Badge className={cn('w-fit', className)} variant="outline">
      {label}
    </Badge>
  );
}
